import { render, staticRenderFns } from "./MatomoLive.vue?vue&type=template&id=34b102c9&"
import script from "./MatomoLive.vue?vue&type=script&lang=js&"
export * from "./MatomoLive.vue?vue&type=script&lang=js&"
import style0 from "./MatomoLive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MatomoLive.vue"
export default component.exports